import React, { useState } from "react";
import { outletMetaData } from "../../features/editAndView/ViewAndEditType";
import { updateOutlet } from "../../services/userService";
import {
  CustomerInformation,
  OtherOutletInfo,
  OutletOverview,
  SalesInformation,
  OutletLoaction,
  PjpBeat,
} from "./OutletModalState";

import "./OutletModal.css";
import { outletForModelType, outletModalType } from "./OutletModalTypes";
import ViewAndEditModal from "../viewAndEditModal/ViewAndEditModal";
import { TranslationEnum, usePortalTranslation } from "../../providers/TranslationProvider";

const OutletModal = ({
  modelData,
  close,
  setGenericMetaData,
  getTableRows,
  additionaCachedData,
  disableEdit
}: outletModalType) => {
  const { translate } = usePortalTranslation();
  const CUR_COMPONENT_COMMON="commonPortal";
  const CUR_COMPONENT="OutletDetails";
  const [activeButton, setActiveButton] = useState(0);

  const [check, setCheck] = useState(false);

  const [defaultInputs, setDefaultInputs] = useState<outletMetaData>(modelData);

  const [editRequestBody, setEditRequestBody] = useState<outletForModelType>({
    outletCode: modelData.outletCode,
    outletName: modelData.outletName,
  });

  const [validEmail, setValidEmail] = useState(true);

  const [validMobile, setValidMobile] = useState(true);

  const changeModalState = (activeButton: number) => {
    switch (activeButton) {
      case 0:
        return (
          <OutletOverview
            disableEdit={disableEdit} 
            modelData={modelData}
            submit={{ check, setCheck }}
            additionalCachedData={additionaCachedData}
            defaultInputs={{ defaultInputs, setDefaultInputs }}
            requestBody={{ editRequestBody, setEditRequestBody }}
          />
        );
      case 1:
        return (
          <SalesInformation
            disableEdit={disableEdit} 
            defaultInputs={{ defaultInputs, setDefaultInputs }}
            submit={{ check, setCheck }}
            requestBody={{ editRequestBody, setEditRequestBody }}
            additionalCachedData={additionaCachedData}
          />
        );
      case 2:
        return (
          <CustomerInformation
            disableEdit={disableEdit} 
            defaultInputs={{ defaultInputs, setDefaultInputs }}
            submit={{ check, setCheck }}
            requestBody={{ editRequestBody, setEditRequestBody }}
            validEmail={{ validEmail, setValidEmail }}
            validMobile={{ validMobile, setValidMobile }}
          />
        );
      case 3:
        return (
          <OutletLoaction
            defaultInputs={{ defaultInputs, setDefaultInputs }}
            submit={{ check, setCheck }}
            requestBody={{ editRequestBody, setEditRequestBody }}
          />
        );
      case 4:
        return (
          <PjpBeat
            disableEdit={disableEdit} 
            modelData={modelData}
            submit={{ check, setCheck }}
            additionalCachedData={additionaCachedData}
            defaultInputs={{ defaultInputs, setDefaultInputs }}
            requestBody={{ editRequestBody, setEditRequestBody }}
          />
        );
      case 5:
        return (
          <OtherOutletInfo
            defaultInputs={{ defaultInputs, setDefaultInputs }}
            submit={{ check, setCheck }}
            requestBody={{ editRequestBody, setEditRequestBody }}
          />
        );

      default:
    }
  };

  const uploadOutletData = async () => {
    if (validEmail && validMobile && check) {
      const response = await updateOutlet(editRequestBody);
      if (response.status === 200 || response.status === 201) {
        setGenericMetaData(translate(TranslationEnum.common_portal,"Successfully updated the data"), "Success", true);
      } else {
        setGenericMetaData(
          "Some error occured while updating the data",
          "Error",
          true
        );
      }
    }
    close();
  };
  return (
    <ViewAndEditModal
      message={translate(TranslationEnum.common_portal,"Edit a record")}
      closeModal={close}
      updateMethod={uploadOutletData}
      check={check}
    >
      <div className="modal-content">
        <div className="modal-states">
          <button
            onClick={() => {
              setActiveButton(0);
            }}
            className={
              activeButton === 0
                ? "active-model-button model-button"
                : "model-button"
            }
          >
            {translate(TranslationEnum.outlet_details,"Outlet Overview")}
          </button>
          <button
            onClick={() => {
              setActiveButton(1);
            }}
            className={
              activeButton === 1
                ? "active-model-button model-button"
                : "model-button"
            }
          >
             {translate(TranslationEnum.outlet_details,"Sales Information")}
          </button>
          <button
            onClick={() => {
              setActiveButton(2);
            }}
            className={
              activeButton === 2
                ? "active-model-button model-button"
                : "model-button"
            }
          >
             {translate(TranslationEnum.outlet_details,"Customer Information")}
          </button>
          <button
            onClick={() => {
              setActiveButton(4);
            }}
            className={
              activeButton === 4
                ? "active-model-button model-button"
                : "model-button"
            }
          >
             {translate(TranslationEnum.outlet_details,"Pjp Beat")}
          </button>
         
        </div>
        {changeModalState(activeButton)}
      </div>
    </ViewAndEditModal>
  );
};

export default OutletModal;
